export const recommendedSites = [
  {
    id: 'site-1',
    name: '星辰影院',
    url: 'https://fjhcjykj.cn/xingchen',
    rating: 4.8,
    category: '电影',
    tags: ['高清画质', '更新快速', '无广告'],
    description: '国内领先的免费在线观影平台，提供超清1080P画质，每日更新热门电影和电视剧资源，支持多线路切换，播放流畅不卡顿。',
    logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20golden%20star%20logo%20design%20on%20warm%20cream%20background%2C%20elegant%20cinema%20platform%20brand%20identity%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20professional%20and%20trustworthy%20feel&width=200&height=200&seq=site-logo-01&orientation=squarish',
  },
  {
    id: 'site-2',
    name: '极光影城',
    url: 'https://fjhcjykj.cn/jiguang',
    rating: 4.7,
    category: '剧集',
    tags: ['海量资源', '蓝光画质', '中文字幕'],
    description: '拥有海量影视资源库，涵盖国内外热门电影、电视剧、综艺节目，支持蓝光画质播放，提供精准中文字幕，观影体验极佳。',
    logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20aurora%20light%20logo%20icon%20on%20warm%20cream%20background%2C%20elegant%20cinema%20platform%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20modern%20and%20premium%20feel&width=200&height=200&seq=site-logo-02&orientation=squarish',
  },
  {
    id: 'site-3',
    name: '蓝鲸影视',
    url: 'https://fjhcjykj.cn/lanjing',
    rating: 4.6,
    category: '综艺',
    tags: ['综艺齐全', '实时更新', '弹幕互动'],
    description: '专注综艺节目和纪录片的优质平台，实时同步更新各大卫视热门综艺，支持弹幕互动功能，让观看体验更加有趣。',
    logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20blue%20whale%20silhouette%20logo%20on%20warm%20cream%20background%2C%20elegant%20entertainment%20platform%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20friendly%20and%20modern%20feel&width=200&height=200&seq=site-logo-03&orientation=squarish',
  },
  {
    id: 'site-4',
    name: '樱花动漫',
    url: 'https://fjhcjykj.cn/yinghua',
    rating: 4.5,
    category: '动漫',
    tags: ['日漫美漫', '国漫专区', '高清无删减'],
    description: '动漫爱好者的天堂，提供海量日本动漫、美国动漫及国产动漫资源，高清无删减版本，更新速度业界领先。',
    logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20cherry%20blossom%20petal%20logo%20on%20warm%20cream%20background%2C%20elegant%20anime%20platform%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20playful%20yet%20sophisticated%20feel&width=200&height=200&seq=site-logo-04&orientation=squarish',
  },
  {
    id: 'site-5',
    name: '飞鱼影视',
    url: 'https://fjhcjykj.cn/feiyu',
    rating: 4.4,
    category: '电影',
    tags: ['新片速递', '多线路', '无需注册'],
    description: '无需注册即可免费观看最新电影大片，提供多条播放线路自动切换，画质从标清到4K随心选择，观影零门槛。',
    logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20flying%20fish%20silhouette%20logo%20on%20warm%20cream%20background%2C%20elegant%20streaming%20platform%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20dynamic%20and%20modern%20feel&width=200&height=200&seq=site-logo-05&orientation=squarish',
  },
  {
    id: 'site-6',
    name: '星河TV',
    url: 'https://fjhcjykj.cn/xinghe',
    rating: 4.3,
    category: '剧集',
    tags: ['美剧韩剧', '日剧泰剧', '双语字幕'],
    description: '海外剧集爱好者的首选平台，涵盖美剧、韩剧、日剧、泰剧等热门资源，提供双语字幕，追剧体验一流。',
    logoUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20galaxy%20spiral%20logo%20on%20warm%20cream%20background%2C%20elegant%20global%20streaming%20platform%20branding%2C%20clean%20vector%20style%2C%20soft%20gradient%2C%20cosmopolitan%20and%20premium%20feel&width=200&height=200&seq=site-logo-06&orientation=squarish',
  },
];

export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-film-line', count: 128 },
  { slug: 'series', name: '剧集', icon: 'ri-tv-line', count: 96 },
  { slug: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line', count: 64 },
  { slug: 'anime', name: '动漫', icon: 'ri-ghost-line', count: 82 },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line', count: 45 },
];

export const featuredArticles = [
  {
    id: 'article-1',
    slug: 'best-free-movie-sites-2025',
    title: '2025年最好的免费看片网站大盘点：这10个网站让你畅享高清影视',
    excerpt: '还在为找不到好的看片网站发愁？本文为你精心整理了2025年最值得收藏的10个免费在线观影平台，从画质、资源量、更新速度等多维度进行深度评测，助你轻松找到最适合的观影神器。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20home%20theater%20scene%20with%20a%20large%20screen%20displaying%20movie%20content%2C%20cozy%20living%20room%20with%20soft%20warm%20lighting%2C%20popcorn%20on%20a%20wooden%20coffee%20table%2C%20modern%20minimalist%20interior%2C%20golden%20hour%20ambient%20light%2C%20relaxing%20atmosphere%2C%20professional%20photography&width=800&height=450&seq=article-cover-01&orientation=landscape',
    category: '电影',
    date: '2025-08-10',
    readTime: '8分钟',
  },
  {
    id: 'article-2',
    slug: 'high-quality-anime-sites-2025',
    title: '二次元必看！2025年高清动漫看片网站推荐合集',
    excerpt: '动漫迷们注意了！本文汇总了目前最优质的动漫在线观看平台，无论你是日漫党、美漫迷还是国漫爱好者，都能在这里找到最适合你的动漫看片网站。高清画质、无删减版本，一键追番从未如此简单。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20warm%20anime%20watching%20setup%20with%20colorful%20anime%20posters%20on%20the%20wall%2C%20a%20laptop%20displaying%20anime%20content%2C%20cozy%20desk%20with%20anime%20figurines%2C%20soft%20warm%20lighting%2C%20modern%20room%2C%20vibrant%20yet%20cozy%20atmosphere%2C%20professional%20photography&width=800&height=450&seq=article-cover-02&orientation=landscape',
    category: '动漫',
    date: '2025-08-08',
    readTime: '6分钟',
  },
  {
    id: 'article-3',
    slug: 'how-to-choose-streaming-site',
    title: '如何挑选靠谱的看片网站？5个关键指标帮你避开所有坑',
    excerpt: '网上看片网站那么多，怎样才能避开广告陷阱和低质平台？本文从画质清晰度、广告干扰程度、资源更新速度、播放流畅度和网站安全性五个维度，教你科学筛选优质的在线看片网站。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20person%20using%20a%20laptop%20on%20a%20wooden%20desk%20with%20a%20magnifying%20glass%20icon%20overlay%2C%20warm%20natural%20light%20from%20a%20window%2C%20minimalist%20workspace%2C%20clean%20and%20professional%20setting%2C%20soft%20warm%20tones%2C%20editorial%20photography&width=800&height=450&seq=article-cover-03&orientation=landscape',
    category: '指南',
    date: '2025-08-05',
    readTime: '10分钟',
  },
];

export const stats = [
  { value: '200+', label: '精选网站' },
  { value: '50万+', label: '月活跃用户' },
  { value: '98%', label: '用户满意度' },
  { value: '每日更新', label: '资源同步' },
];

export const faqs = [
  {
    question: '这些看片网站真的免费吗？',
    answer: '是的，我们推荐的看片网站均提供免费在线观看服务。大部分网站通过广告收入维持运营，用户无需付费即可畅享海量影视资源。我们优先筛选广告较少、体验流畅的平台，确保您获得最佳的免费观影体验。',
  },
  {
    question: '看片网站的画质怎么样？支持4K吗？',
    answer: '我们推荐的看片网站普遍支持1080P高清画质，部分网站如星辰影院、极光影城等已支持4K超清画质。您可以根据自己的网络状况和设备选择适合的清晰度。建议使用稳定网络环境以获得最佳观影效果。',
  },
  {
    question: '手机可以看吗？需要下载APP吗？',
    answer: '完全可以！所有推荐的看片网站均支持手机浏览器直接访问，无需下载任何APP。网站采用响应式设计，自动适配手机、平板和电脑屏幕。您只需在手机浏览器中打开网站即可随时随地畅享观影，非常方便。',
  },
  {
    question: '这些网站更新速度快吗？最新电影什么时候能看？',
    answer: '我们推荐的看片网站更新速度都非常快。热门电影通常在院线下线后1-2周内即可观看，热门剧集一般在播出后24小时内更新。部分网站如星辰影院、飞鱼影视的更新速度更是业界领先，基本实现同步更新。',
  },
  {
    question: '网站安全吗？会不会有病毒？',
    answer: '我们对推荐的每一个看片网站都进行了严格的安全审核，确保网站不含恶意代码和病毒。建议您直接通过浏览器访问网站，避免点击站内第三方弹窗广告。如遇到强制跳转的广告页面，直接关闭即可，不会对设备造成影响。',
  },
  {
    question: '为什么有些网站今天能看明天就打不开了？',
    answer: '部分免费看片网站可能会因域名更换或服务器维护而暂时无法访问。我们建议您收藏多个备选网站，以便在主站无法访问时及时切换。本页面会持续更新网站最新可用地址，您可以定期回访获取最新信息。',
  },
];